import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppServiceService } from '../../app-service.service';
import { contactAnimatePage, contactMobileInfo, contactMobileShopFinder } from '../../animation/animate';
import { ApiService } from '../../api.service';
import { UiService } from '../../ui.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { WindowService } from '../../window.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  animations: [
    contactAnimatePage, 
    contactMobileInfo, 
    contactMobileShopFinder
  ],
  host: { '[@contactAnimatePage]': '' }
})
export class ContactComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<boolean> = new Subject();
  private post:any;
  public theme:any = {
    'social' : {
      'facebook' : '',
      'instagram': ''
    }
  };
  private message:any = {
    'email' : '',
    'name'  : ''
  };
  private activeSearchValue:boolean = false;
  private country:any = [];
  private send:string = '';
  private search: string = '';
  private steteInfo:string = 'show';
  private steteShopFinder:string = 'show';
  public screen:any = {
    'width' : '1920',
    'height': '1080'
  };

  constructor(
    private app: AppServiceService,
    private api: ApiService,
    private route: ActivatedRoute, 
    private UI: UiService
  ) { 
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post = data.data;
      this.country = this.post.country;
      this.theme  = data.theme;
    })

    this.app.normalMenu.next(true);
  }

  subscribe(){
    this.api.subscribeUser(this.message).subscribe(data => {
        this.send = 'done';
        this.message = {
          'email' : '',
          'name'  : ''
        };
    });
  }

  /*
  * change state contact
  */

  toggleBlock(){
    this.steteInfo = this.steteInfo == 'show' ? 'hide' : 'show';
    this.steteShopFinder = this.steteShopFinder == 'show' ? 'hide' : 'show';
  }

  getNumber(num:string){
    return num.replace(/[ \+]/gi,'');
  }

  cutPhone(phone:string){
    return phone.replace(/ -/g, '');
  }

  activeSearch(){
    this.activeSearchValue = true;
    this.country = this.post.country.filter(el => {
      return el.title.toLocaleLowerCase().includes(this.search);
    });
  }

  setTerm($event){
    let attr = $event.target.value.split('|');
    this.api.getStorage(attr[0]).pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post.stores = data;
      this.UI.initMap(this.post.stores);
    })
  }

  ngOnInit() {
    //screen
    this.screen = this.app.screen;
    this.app.screenSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.screen = this.app.screen;
    })

    //this.UI.horizontallScroll();
    this.app.blackStyle.next(true);
    setTimeout(() => {
      this.UI.styleSelect();
    }, 1000);
    setTimeout(() => {
      this.app.title.next(this.post.title);
      this.app.showLeftPanel.next(true);   
      this.app.activeMenu.next(true);
    }, 2000);
    setTimeout(() => {
      this.app.titleLeftPanel.next(true);
      this.UI.initMap(this.post.stores);
    }, 3000);
    if(this.UI.widthMobile()){
      this.steteShopFinder = 'hide';
    }
  }

  ngOnDestroy(){
    this.app.titleLeftPanel.next(false);

    this.app.activeMenu.next(false);
    this.app.menuState.next('hide');
    this.app.submenuState.next('hide');
    this.app.blackStyle.next(false);

    setTimeout(() => {
      this.app.title.next('');
    }, 500);

    //unsabscribe
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/contact/contact/contact.component.ts